/* ============================================================
   MYPI — COLLECTION SCRIPT (Shopify port of the reference collection.js)

   The reference filtered/sorted/paginated a static grid client-side.
   Here the identical UX drives Shopify Storefront Filtering: every
   facet, sort or page change serialises the facet form, fetches this
   section's HTML via the Section Rendering API (section_id) and swaps
   the changed regions in place, then pushState-updates the URL.

   Deltas from the reference (documented in the section file too):
   - the three price "bands" are translated into one
     filter.v.price.gte/lte envelope — multiple non-adjacent bands
     collapse to their min-max envelope (native-filtering limitation);
   - facet counts / is-empty states come re-rendered from the server
     (Shopify narrows counts against the other applied filters);
   - the drawer / group-collapse / scroll behaviour is the reference
     logic verbatim, with classes renamed to the mypi- prefix.
   ============================================================ */
(function () {
  'use strict';

  var current = null; // active collection instance (re-set on editor section reload)
  function active() {
    return current && document.contains(current.root) ? current : null;
  }
  document.addEventListener('click', function (e) {
    var c = active();
    if (!c || !c.drawer || !c.drawer.classList.contains('is-open')) return;
    if (e.target.closest('#collectionFilters')) return;
    if (e.target.closest('#filterToggle') || e.target.closest('[data-filter-pill]')) return;
    c.closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    var c = active();
    if (c && e.key === 'Escape') c.closeDrawer();
  });
  // Design v3: the drawer is the filter UI at every width (no desktop auto-close)
  window.addEventListener('resize', function () {
    var c = active();
    if (c) c.syncGroups();
  });
  window.addEventListener('popstate', function () {
    var c = active();
    if (c && c.onPopstate) c.onPopstate();
  });

  function init(root) {
    if (!root || root.__mypiCollection) return;
    root.__mypiCollection = true;

    var $ = window.MYPI.$, $$ = window.MYPI.$$;
    var sectionId = root.dataset.sectionId;
    var form = $('#FacetsForm', root);
    var sortSelect = $('#sortSelect', root);
    var sortInput = form ? $('input[data-sort-input]', form) : null;
    var drawer = $('#collectionFilters', root);
    var scrim = $('#filterScrim', root);
    var toggle = $('#filterToggle', root);

    /* ---------- collapsible filter groups (reference logic) ---------- */
    function syncGroup(g) {
      var head = $('.mypi-fgroup__head', g), body = $('.mypi-fgroup__body', g);
      if (!head || !body) return;
      var open = g.classList.contains('is-open');
      head.setAttribute('aria-expanded', open);
      body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
    }
    function syncGroups() { $$('.mypi-fgroup', root).forEach(syncGroup); }

    /* ---------- mobile filter drawer (reference timings) ---------- */
    function openDrawer() {
      if (!drawer || !scrim) return;
      scrim.hidden = false;
      requestAnimationFrame(function () { scrim.classList.add('is-open'); });
      drawer.classList.add('is-open');
      // re-query: the toolbar pills are swapped on every AJAX filter change
      var t = $('#filterToggle', root);
      if (t) t.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      syncGroups();
    }
    function closeDrawer() {
      if (!drawer || !scrim) return;
      scrim.classList.remove('is-open');
      drawer.classList.remove('is-open');
      var t = $('#filterToggle', root);
      if (t) t.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () { if (!scrim.classList.contains('is-open')) scrim.hidden = true; }, 320);
    }
    // Design v3: the facet pills (incl. #filterToggle) open the drawer.
    // Delegated on root so the bindings survive the .mypi-cpills swap.
    root.addEventListener('click', function (e) {
      if (e.target.closest('#filterToggle')) {
        drawer && drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
      } else if (e.target.closest('[data-filter-pill]')) {
        openDrawer();
      }
    });
    var closeBtn = $('#filterClose', root);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);
    // Outside-click close (click also fires for taps, not for scrolls/swipes).
    // Document/window listeners are bound once at module level and dispatch
    // to the current instance (avoids stacking on editor section reloads).
    current = { root: root, drawer: drawer, closeDrawer: closeDrawer, syncGroups: syncGroups };

    /* ---------- price bands → gte/lte envelope ---------- */
    function updatePriceEnvelope() {
      var gte = $('input[data-price-envelope="gte"]', form);
      var lte = $('input[data-price-envelope="lte"]', form);
      if (!gte || !lte) return;
      var bands = $$('input[data-price-band]', form).filter(function (b) { return b.checked; });
      if (!bands.length) { gte.disabled = true; lte.disabled = true; return; }
      var min = Infinity, max = 0;
      bands.forEach(function (b) {
        var bMin = parseFloat(b.dataset.min || '0');
        var bMax = b.dataset.max ? parseFloat(b.dataset.max) : Infinity;
        if (bMin < min) min = bMin;
        if (bMax > max) max = bMax;
      });
      if (min > 0) { gte.disabled = false; gte.value = min; } else { gte.disabled = true; }
      if (max !== Infinity) { lte.disabled = false; lte.value = max; } else { lte.disabled = true; }
    }

    /* ---------- section fetch + region swap ---------- */
    var pendingCtrl = null;
    function fetchSection(qs) {
      if (pendingCtrl) pendingCtrl.abort();
      pendingCtrl = window.AbortController ? new AbortController() : null;
      var url = window.location.pathname + '?' + (qs ? qs + '&' : '') + 'section_id=' + sectionId;
      var opts = pendingCtrl ? { signal: pendingCtrl.signal } : {};
      return fetch(url, opts)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          pendingCtrl = null;
          return new DOMParser().parseFromString(html, 'text/html');
        });
    }

    function buildQuery(page) {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { params.append(k, v); });
      if (page && page > 1) params.set('page', page);
      return params.toString();
    }

    function swapFromDoc(doc) {
      // aria-live count: swap contents, keep the live region node
      var count = doc.querySelector('#resultCount'), oldCount = $('#resultCount', root);
      if (count && oldCount) oldCount.innerHTML = count.innerHTML;

      ['#filterChips', '#productGrid', '#emptyState', '#pager', '#showing', '.mypi-cpills'].forEach(function (sel) {
        var next = doc.querySelector(sel), prev = $(sel, root);
        if (next && prev) prev.replaceWith(next);
      });

      var fcl = doc.querySelector('#filterCountLabel'), oldFcl = $('#filterCountLabel', root);
      if (fcl && oldFcl) oldFcl.textContent = fcl.textContent;
      var applyBtn = doc.querySelector('#filterApply'), oldApply = $('#filterApply', root);
      if (applyBtn && oldApply) oldApply.textContent = applyBtn.textContent;

      // facet groups: swap wholesale, preserving collapse state + focus
      // (keeps the mobile drawer itself open — only its contents change)
      var oldGroups = $('.mypi-cfilters__groups', root);
      var newGroups = doc.querySelector('.mypi-cfilters__groups');
      if (oldGroups && newGroups) {
        var openState = {};
        $$('.mypi-fgroup', oldGroups).forEach(function (g) {
          var head = $('.mypi-fgroup__head', g);
          if (head) openState[head.textContent.trim()] = g.classList.contains('is-open');
        });
        var ae = document.activeElement, focusKey = null;
        if (ae && oldGroups.contains(ae) && ae.tagName === 'INPUT') {
          focusKey = {
            name: ae.name || '',
            value: ae.value || '',
            band: ae.getAttribute('data-price-band') || ''
          };
        }
        oldGroups.replaceWith(newGroups);
        $$('.mypi-fgroup', newGroups).forEach(function (g) {
          var head = $('.mypi-fgroup__head', g);
          var key = head ? head.textContent.trim() : '';
          if (key in openState) g.classList.toggle('is-open', openState[key]);
        });
        if (focusKey) {
          var match = $$('input', newGroups).filter(function (i) {
            return focusKey.band
              ? i.getAttribute('data-price-band') === focusKey.band
              : (i.name === focusKey.name && i.value === focusKey.value);
          })[0];
          if (match) match.focus({ preventScroll: true });
        }
      }
      syncGroups();
    }

    function applyFilters(page, push) {
      var qs = buildQuery(page);
      return fetchSection(qs).then(function (doc) {
        swapFromDoc(doc);
        if (push !== false) {
          history.pushState({ mypiCollection: true }, '', window.location.pathname + (qs ? '?' + qs : ''));
        }
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        // graceful fallback: let the server render the filtered page
        window.location.href = window.location.pathname + (qs ? '?' + qs : '');
      });
    }

    function findFacetInput(name, value) {
      return $$('input[type="checkbox"][name]', form).filter(function (i) {
        return i.name === name && i.value === value;
      })[0] || null;
    }

    function clearAll() {
      $$('input[type="checkbox"]', form).forEach(function (i) { i.checked = false; });
      $$('.mypi-fcolour.is-active', form).forEach(function (l) { l.classList.remove('is-active'); });
      updatePriceEnvelope();
      applyFilters();
    }

    function scrollToToolbar() {
      var bar = $('.mypi-ctoolbar', root);
      if (!bar) return;
      var top = bar.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    /* ---------- facet form: change = apply (reference behaviour) ---------- */
    if (form) {
      form.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || input.type !== 'checkbox') return;
        if (input.hasAttribute('data-price-band')) updatePriceEnvelope();
        var lab = input.closest('.mypi-fcolour');
        if (lab) lab.classList.toggle('is-active', input.checked);
        applyFilters();
      });
      // filters are applied on change; "View N Results" just closes the drawer
      // (with JS off, this same button is the native GET submit)
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    }

    /* ---------- sort ---------- */
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var v = sortSelect.value;
        if (sortInput) {
          if (v === (sortSelect.dataset.defaultSort || '')) {
            sortInput.disabled = true;
          } else {
            sortInput.disabled = false;
            sortInput.value = v;
          }
        }
        applyFilters();
      });
    }

    /* ---------- chips, clear-all, empty state, pager (delegated) ---------- */
    root.addEventListener('click', function (e) {
      var head = e.target.closest('.mypi-fgroup__head');
      if (head && root.contains(head)) {
        var g = head.closest('.mypi-fgroup');
        if (g) { g.classList.toggle('is-open'); syncGroup(g); }
        return;
      }

      var chip = e.target.closest('.mypi-cchip');
      if (chip) {
        if (chip.hasAttribute('data-price-chip')) {
          var band = chip.getAttribute('data-band');
          $$('input[data-price-band]', form).forEach(function (b) {
            if (band === 'all' || b.getAttribute('data-price-band') === band) b.checked = false;
          });
          updatePriceEnvelope();
        } else {
          var input = findFacetInput(chip.getAttribute('data-param'), chip.getAttribute('data-value'));
          if (input) {
            input.checked = false;
            var lab = input.closest('.mypi-fcolour');
            if (lab) lab.classList.remove('is-active');
          }
        }
        applyFilters();
        return;
      }

      if (e.target.closest('[data-clear-all]') || e.target.closest('#emptyClear')) {
        clearAll();
        return;
      }

      var pageLink = e.target.closest('#pager a[data-page]');
      if (pageLink) {
        e.preventDefault();
        var page = parseInt(pageLink.getAttribute('data-page'), 10) || 1;
        applyFilters(page).then(scrollToToolbar);
      }
    });

    /* ---------- back/forward ---------- */
    current.onPopstate = function () {
      var qs = window.location.search.replace(/^\?/, '');
      fetchSection(qs).then(function (doc) {
        swapFromDoc(doc);
        var sp = new URLSearchParams(window.location.search);
        // reflect the restored sort in the toolbar select + hidden input
        var newSort = doc.querySelector('#sortSelect');
        if (newSort && sortSelect) {
          var v = newSort.value;
          if ($('option[value="' + v + '"]', sortSelect)) sortSelect.value = v;
        }
        if (sortInput) {
          var sv = sp.get('sort_by');
          if (sv) { sortInput.disabled = false; sortInput.value = sv; }
          else { sortInput.disabled = true; }
        }
        // re-derive the hidden price envelope from the restored URL
        ['gte', 'lte'].forEach(function (kind) {
          var inp = $('input[data-price-envelope="' + kind + '"]', form);
          if (!inp) return;
          var pv = sp.get(inp.name);
          if (pv) { inp.disabled = false; inp.value = pv; }
          else { inp.disabled = true; }
        });
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.reload();
      });
    };

    syncGroups();
  }

  function boot(scope) {
    if (!window.MYPI) return;
    var root = (scope || document).querySelector('[data-mypi-collection]');
    if (root) init(root);
  }

  boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
